import { render, staticRenderFns } from "./OptCost.vue?vue&type=template&id=4db0e745&"
import script from "./OptCost.vue?vue&type=script&lang=js&"
export * from "./OptCost.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports